import React from 'react';
import _isEqual from 'lodash/isEqual';
import _pickBy from 'lodash/pickBy';
import _isEmpty from 'lodash/isEmpty';
import * as Types from 'pages/Features/tabs/Profile/TimezoneAndWorkHours/typings';

import makeStyles from '@material-ui/core/styles/makeStyles';

import Switch from '@material-ui/core/Switch';
import Typography from '@material-ui/core/Typography';
import WorkHoursForm from './WorkHoursForm';

interface Props {
  value: Types.TimezoneAndWorkHoursFormState;
  errors: any;
  onChange: (key: string, value: any) => void;
}

function TimezoneAndWorkHours({ value, errors, onChange }: Props) {
  const classes = useStyles();
  const { timezoneEnabled, workScheduleEnabled } = value;

  const handleToggleEnableTimezone = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange('client.settings.timezoneAndWorkHours.timezoneEnabled', e.target.checked);

    if (!e.target.checked) {
      onChange('client.settings.timezoneAndWorkHours.workScheduleEnabled', false);
      onChange('client.settings.timezoneAndWorkHours.hoursEnabled', false);
      onChange('client.settings.timezoneAndWorkHours.locationEnabled', false);
      onChange('client.settings.timezoneAndWorkHours.defaultWorkHoursEnabled', false);
    }
  };

  const handleToggleEnableWorkSchedule = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange('client.settings.timezoneAndWorkHours.workScheduleEnabled', e.target.checked);
    onChange('client.settings.timezoneAndWorkHours.hoursEnabled', e.target.checked);
    onChange('client.settings.timezoneAndWorkHours.locationEnabled', e.target.checked);

    if (!e.target.checked) {
      onChange('client.settings.timezoneAndWorkHours.defaultWorkHoursEnabled', false);
    }
  };

  return (
    <>
      <div className={classes.content}>
        <Typography variant="h6">Time Zone</Typography>
        <Switch
          checked={timezoneEnabled}
          inputProps={{ 'aria-label': 'time zone switch' }}
          onChange={handleToggleEnableTimezone}
        />
      </div>
      <Typography variant="subtitle2">
        Allow users to add their local time zone to their profile.
      </Typography>
      <div className={classes.workHoursSection}>
        <div className={classes.content}>
          <Typography variant="h6">Work Schedule</Typography>
          <Switch
            checked={workScheduleEnabled}
            disabled={!timezoneEnabled}
            inputProps={{ 'aria-label': 'work schedule switch' }}
            onChange={handleToggleEnableWorkSchedule}
          />
        </div>
        <Typography variant="subtitle2">
          Allow users to add their daily working hours to their profile. You can set default working
          hours for your organization below.
        </Typography>
        <WorkHoursForm value={value} errors={errors} onChange={onChange} />
      </div>
    </>
  );
}

const useStyles = makeStyles(theme => ({
  root: {},
  workHoursSection: {
    marginTop: theme.spacing(1.5),
  },
  content: {
    display: 'flex',
    justifyContent: 'space-between',
  },
}));

export default TimezoneAndWorkHours;
